module.exports = __webpack_public_path__ + "img/yd.44579f35.png";